import { MutationTuple, useMutation } from '@apollo/client';
import { ReturnCaddiesInput, ReturnCaddiesPayload } from '@bechtel/types';
import { RETURN_CADDIES } from '@bechtel/client-gql';

export function useReturnCaddy(
  onActionCompleted?: () => void
): MutationTuple<{ returnCaddies: ReturnCaddiesPayload }, { input: ReturnCaddiesInput }> {
  const response = useMutation<{ returnCaddies: ReturnCaddiesPayload }, { input: ReturnCaddiesInput }>(RETURN_CADDIES, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      if (onActionCompleted) onActionCompleted();
    },
    onError: () => {
      if (onActionCompleted) onActionCompleted();
    },
  });
  return response;
}
